export enum Rating {
  none = 0,
  mustImprove = 1,
  satisfactory = 2,
  good = 3,
  outstanding = 4
}
